"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
exports.snapSubtitleDelay = exports.SUBTITLES_DELAY_REPEAT_INTERVAL_MS = exports.SUBTITLES_DELAY_REPEAT_DELAY_MS = exports.SUBTITLES_DELAY_STEP_MS = exports.getSubtitleDelayStepMultiplier = void 0;
var SUBTITLES_DELAY_STEP_MS = 100;
exports.SUBTITLES_DELAY_STEP_MS = SUBTITLES_DELAY_STEP_MS;
var SUBTITLES_DELAY_REPEAT_DELAY_MS = 250;
exports.SUBTITLES_DELAY_REPEAT_DELAY_MS = SUBTITLES_DELAY_REPEAT_DELAY_MS;
var SUBTITLES_DELAY_REPEAT_INTERVAL_MS = 100;
exports.SUBTITLES_DELAY_REPEAT_INTERVAL_MS = SUBTITLES_DELAY_REPEAT_INTERVAL_MS;
var INITIAL_STEP_MULTIPLIER = 3;
var MAX_STEP_MULTIPLIER = 6;
var snapSubtitleDelay = function (delay, direction) {
    var snap = direction > 0 ? Math.floor : Math.ceil;
    return snap(delay / SUBTITLES_DELAY_STEP_MS) * SUBTITLES_DELAY_STEP_MS;
};
exports.snapSubtitleDelay = snapSubtitleDelay;
var getSubtitleDelayStepMultiplier = function (heldForMs) {
    return Math.min(Math.floor(heldForMs / 1000) + INITIAL_STEP_MULTIPLIER, MAX_STEP_MULTIPLIER);
};
exports.getSubtitleDelayStepMultiplier = getSubtitleDelayStepMultiplier;
